/**
 * store中的数据会实时备份到本地存储中
 * 用以重载页面时恢复到上一次状态
 * 所有零售线路的共用一个key，即STORAGE_KEY
 *
 * 另每个零售详情各自生成一个唯一的key
 * 与数据共同存储在本地存储中
 * 在取数据时作为数据一致的判断凭据
 *
 * @see http://wiki.tuniu.org/pages/viewpage.action?pageId=75712365
 * @module storage
 */

import Storage from '@/plugins/storage/Storage';
import {STORAGE_TIMEOUT, STORAGE_KEY} from '@/config';

let storageKey = '';

let storage = new Storage({
    type: 'session',
    timeout: STORAGE_TIMEOUT
});

/**
 * 创建存储key
 * @param  {Array} params 参数列表
 * @return {String}
 */
function buildStorageKey(params) {
    return [STORAGE_KEY].concat(params.map(param => String(param))).join('-');
}

export default {
    /**
     * 当前数据的唯一key，与数据一起保存在storage中
     * 在取数据的时候判断是否为当前线路的数据
     */
    setKey() {
        storageKey = buildStorageKey([].slice.call(arguments));
    },

    /**
     * 获取storage中的缓存的数据
     * @return {Object|Null}
     */
    get() {
        let data = storage.get(STORAGE_KEY);
        if (data) {
            if (data.key === storageKey) {
                return data.data;
            } else {
                storage.clear(STORAGE_KEY);
            }
        }

        return null;
    },

    /**
     * 保存数据到storage
     * @param  {Object} data
     */
    save(data) {
        storage.set(STORAGE_KEY, {
            key: storageKey,
            data: data
        });
    },

    clear() {
        storage.clear(STORAGE_KEY);
    }
}



// WEBPACK FOOTER //
// libs/util/storage.js